export const paths = {
  valuationAnnualReport: () => '/valuation-annual-report',
}
